<template>
    <div class="">
        <section v-if="props?.boxValue === 'diamColor' || props?.boxValue === 'accColor'">
            <div class="title_block">

                <h3 class="mb-0 font-active">Fancy Diamond Color :
                    <span> {{ item?.center_color_stone_d_color ||item?.side_color_stone_d_color }}</span>
                </h3>
            </div>
            <div class="mt-3">
                <div class="">

                    <p class="mb-0" v-if="props?.boxValue === 'diamColor'">
                        Fancy diamond color refers to the presence of color within a diamond and is measured on a scale
                        of ‘Faint’ to ‘Fancy Deep’, with ‘Faint’ referring to the lightest color, and ‘Deep’ referring
                        to the deepest color. 
                        
                    </p>
                    <p class="mb-0" v-else>
                        Fancy accent diamond details refer to the presence of color within the accent diamonds and is
                        measured on a scale of ‘Faint’ to ‘Fancy Deep’, with ‘Faint' referring to the lightest color,
                        and ‘Deep’ referring to the deepest color. Our {{ $t('jewelry') }} features fancy diamonds on a
                        scale of ‘Fancy’ to ‘Vivid’.
                    </p>
                    <div class="image_block my-3 text-center" v-if="colorList.length">
                        <div v-for="color in colorList" :key="color" class="d-inline-block mx-2">
                            <img width="180" height="72" :src="'/settingactive/' + lowercase(color) + '.svg'"
                                :alt="color" />
                        </div>
                    </div>
                    <div class="image_block my-3 text-center" v-else>
                        <img width="115" height="72" src="/public/settingactive/fancydiamond.svg" alt="diamond" />
                    </div>
                    <p class="mb-0">Our {{ $t('jewelry') }} features fancy diamonds on a scale of ‘Intense’ to
                        ‘Vivid’.</p>
                </div>
            </div>

        </section>
        <section v-if="props?.boxValue === 'diamClarity' || props?.boxValue === 'accClarity'">
            <div class="title_block">
                <h3 class="mb-0 font-active">
                    Fancy Diamond Clarity :
                    <span>{{ item?.center_color_stone_d_clarity || item?.center_color_stone_d_clarity ||
                        item?.side_color_stone_d_clarity||'' }}</span>
                </h3>
            </div>
            <div class="inital_content" v-if="props?.boxValue === 'diamClarity'">
                <p class="mb-0 mt-2">
                    A fancy diamond’s clarity is determined by how flawless the diamond is. The more inclusions and
                    blemishes a diamond has, the lower its clarity will be. The clarity ranges from ‘Flawless’ to
                    ‘Included’.
                </p>
            </div>
            <div class="mt-3">
                <div class="text-center">
                    <ModalImageScroll :detailData="detailData" :item="resolvedClarity" ref="scroller"
                        :colorClarityBox="boxValue" />
                </div>
               
                <p class="mb-0" v-if="props?.boxValue === 'accClarity'">A fancy accent diamond’s clarity is determined by
                    how flawless the accent diamonds are. The more inclusions and blemishes a diamond has, the lower its
                    clarity will be. The clarity ranges from ‘Flawless’ to ‘Included’. Our {{ $t('jewelry') }} features
                    VS1-VS2 (Very Slightly Included) clarity-graded diamonds that contain inclusions that are virtually
                    invisible to the naked eye.
                </p>
                <p class="mb-0" v-if="props?.boxValue === 'diamClarity'">
                    Our {{ $t('jewelry') }} features VS1-VS2 (Very Slightly Included) clarity-graded
                    diamonds that contain inclusions that are virtually invisible to the naked eye.
                </p>
            </div>

        </section>
    </div>
</template>

<script setup>

const props = defineProps(['boxValue','detailData', 'activeColor', 'color', 'greenitem', 'item', 'detailData'])


const scroller = ref(null);

const resolvedClarity = computed(() => props?.item?.center_normal_stone_d_clarity || props?.item?.center_color_stone_d_clarity);

// clarity

onMounted(() => {

setTimeout(()=>{
    scroller.value?.scrollToHighlightedImage();

    },100)
});
const combinedColors = computed(() => {
  return (
    props.item?.center_color_stone_d_color ||
    props.item?.side_color_stone_d_color ||
    ''
  );
});

// Split colors into an array
const colorList = computed(() => {
  return combinedColors.value
    ? combinedColors.value.split(',').map((color) => color.trim())
    : [];
});

const lowercase = (value) => {
    return value.toLowerCase().replace(/[^\w]/gi, '');
};



</script>



<style scoped>
.largesvg {
    transform: scale(1.3);
}

.img_box {
    height: 130px;
}

.pop_open {
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.title_block {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
}


p {
    font-size: 16px;
    color: #606060;
}

.title_block span {
    cursor: pointer;
    color: var(--green);
}

h3 {
    font-size: 22px;
}

.m-info {
    margin: 10px 0;
}

.image_block {
    text-align: center;
}

.title {
    text-transform: capitalize;
    color: #668b84;
    font-size: 16px;

}

@media(max-width: 767px) {
    h3 {
        font-size: 20px;
    }

    p {
        font-size: 14px;
    }

    .acc_box {
        min-width: 60px;
        font-size: 14px;
        padding: 3px 8px;
    }
}
</style>